
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import Responsavel from '@/model/resource/Responsavel'
import {success, ID} from 'simpli-web-sdk'
import {Action} from 'vuex-class'

enum WorkingType {
  segADom = 1,
  segASab = 2,
  segASex = 3,
}

@Component
export default class ModalWorkingDays extends Vue {
  @Prop({type: Responsavel, required: true}) responsavel!: Responsavel
  @Action('auth/auth') auth!: Function

  WorkingType = WorkingType
  isDisabled = false

  idConfiguracao: ID = 1

  close() {
    this.$modal.close('workingDays')
  }

  openEvent() {
    this.$emit('open')
    this.idConfiguracao = this.responsavel.idConfiguracaoSlaFk
  }

  closeEvent() {
    this.$emit('close')
  }

  get isButtonDisabled() {
    return this.isDisabled
  }

  async persistIdConfiguracaoFk() {
    this.$await.init('updateWorkingDays')
    this.isDisabled = true
    if (!this.responsavel) {
      return
    }
    this.responsavel.idConfiguracaoSlaFk = this.idConfiguracao
    await this.responsavel.persistConfiguracaoSla(this.responsavel)
    await this.auth
    this.$await.done('updateWorkingDays')
    success('system.success.persist')
    await this.close()
    this.isDisabled = false
  }

  getButtonClass() {
    return this.isDisabled ? 'disabled-button' : 'primary'
  }
}
